import React, { createContext, useContext, useState, useEffect } from 'react';
import i18n from '../utils/i18n';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [selectedLanguage, setSelectedLanguage] = useState(
    localStorage.getItem('selectedLanguage') || 'en'
  );
  const [showLanguageModal, setShowLanguageModal] = useState(
    !localStorage.getItem('selectedLanguage')
  );

  useEffect(() => {
    // Only change i18n language, don't save to localStorage here
    if (selectedLanguage) {
      i18n.changeLanguage(selectedLanguage);
    }
  }, [selectedLanguage]);

  const changeLanguage = (languageCode) => {
    setSelectedLanguage(languageCode);
    // Save to localStorage only when user explicitly selects a language
    localStorage.setItem('selectedLanguage', languageCode);
    setShowLanguageModal(false);
  };

  const value = {
    selectedLanguage,
    changeLanguage,
    showLanguageModal,
    setShowLanguageModal
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};
